import { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { LeadsContext } from "../Context/LeadsContext";
import { getImages } from "../Const";

const AutoComplete = ({ openMobArrow, ciqheader, handleMobArrow = () => { }, inPerson, tabClick }) => {
    const { selectLead, setActiveTab, filteredLeads, searchText, setSearchText, searchExists, getLeads, queryLeadID, setQueryLeadID, filteredArchivedLeadData, filteredSMLeads } = useContext(LeadsContext);

    // Get Url
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();

    const handleClearSearch = () => {
        /*const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete("lead_id");
        searchParams.delete("text");
        searchParams.delete("email");
        const newSearch = searchParams.toString();
        const newUrl = newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname;
        window.history.replaceState({}, "", newUrl);
        window.location.reload();*/

        setSearchParams({});

        setSearchText(""); 
        
        getLeads(true);
    };

    const [showLeads, setShowLeads] = useState(false);
    const [activeSearch, setActiveSearch] = useState(null);
    const handleChange = (e) => {
        setSearchText((prevText) => e.target.value);
    };

    const carIdSearch = (id) => {
        selectLead(id);
        setActiveTab(true);
        setShowLeads(false)
    }

    const showLeadTimeout = () => {
        setShowLeads(true);
        setTimeout(function () {
            setShowLeads(false);
        }, 5000);
    }

    useEffect(() => {
        //console.log("useEffect searchText",searchText);
        // if (searchText) showLeadTimeout();
        setShowLeads(true);
    }, [searchText]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // Perform action on Enter key press
            console.log('Enter key pressed');

            getLeads(false,false,true);
        }
    };
    const autoCompleteRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (autoCompleteRef.current && !autoCompleteRef.current.contains(event.target)) {
                setShowLeads(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const isFirstRender = useRef(true);

    useEffect(() => {
        console.log("tab click",tabClick,isFirstRender.current);

        if(searchText) setSearchText("");
        if (isFirstRender.current) {
            isFirstRender.current = false; // Mark that the first render has occurred
            return; // Skip the effect on the first render
        }

        if((queryLeadID || searchExists)) {
            console.log("clearing search");
            handleClearSearch();
        }
    },[tabClick]);

    return (
        <>
            <div ref={autoCompleteRef} className={`search-box position-relative ${ciqheader ? 'ms-3' : 'ms-5'}`} 
            // onMouseEnter={() => setShowLeads(true)} onMouseLeave={() => showLeadTimeout()}
            >
                <div>
                    <input type='text'
                        className='form-control'
                        placeholder='Search'
                        onChange={(e) => {
                            setActiveSearch('search');
                            handleChange(e);
                        }}
                        value={searchText}
                        onKeyDown={handleKeyPress} 
                    />
                    <span className='search-icon'><i className="fa-solid fa-magnifying-glass"></i></span>
                    {activeSearch === 'search' && (searchText) && (
                        <span
                            className="clear-btn"
                            onClick={handleClearSearch}
                        >
                            <img src={getImages('search-cross.svg')} />
                        </span>
                    )}
                    {(queryLeadID || searchExists) && <button type="button" className="clear-search-btn" onClick={handleClearSearch}>Clear Search <img src={getImages('icon-close-circled.png')}/></button>}
                </div>
                <div
                    className={`cs-search-list ${searchText && showLeads && activeSearch === 'search' ? "d-none d-lg-block" : "d-none"}`}
                // style={{
                //     display: searchText && showLeads ? "d-none d-lg-block" : "d-none"
                // }}
                >
                    {filteredLeads.length === 0 && filteredArchivedLeadData.length === 0  && filteredSMLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.filter((lead) => inPerson ? lead.lead_type == "InPerson" : lead.lead_type != "InPerson").filter((lead, index) => { return index >= 10 ? false : true; }).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ?
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                        <div className="pd-xs-title my-2">{option?.full_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                        
                    )}
                    {!inPerson && filteredArchivedLeadData.length > 0 && filteredArchivedLeadData.filter((lead, index) => {
                        return index >= 10 ? false : true; }).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ?
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                        <div className="pd-xs-title my-2">{option?.full_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                    }
                    {inPerson && filteredSMLeads.length > 0 && filteredSMLeads.filter((lead, index) => {
                        return index >= 10 ? false : true; }).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ?
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                        <div className="pd-xs-title my-2">{option?.full_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div
                    className="cs-search-list d-lg-none"
                    style={{
                        display: searchText && showLeads && activeSearch === 'search' ? "block" : "none"
                    }}
                >
                    {filteredLeads.length === 0 && filteredArchivedLeadData.length === 0  && filteredSMLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.filter((lead, index) => { return index >= 10 ? false : true; }).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ?
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                        <div className="pd-xs-title my-2">{option?.full_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                        <div className="pd-email">{option.email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                    )}
                    {filteredArchivedLeadData.length > 0 && filteredArchivedLeadData.filter((lead, index) => { return index >= 10 ? false : true; }).map((option, index) => (
                        <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                            <div className="autocomplete-items d-flex align-items-center">
                                {option?.Vehicle_Photos ?
                                    <div className="cssl-img position-relative">
                                        <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                        {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                    </div> :
                                    <div className='pd-no-img position-relative no-photo-pos'>
                                        <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                    </div>
                                }
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                    <div className="pd-xs-title my-2">{option?.full_name}</div>
                                    <div className="pd-email">{option.email}</div>
                                </div>
                                {/* }
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                    <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                    <div className="pd-email">{option.email}</div>
                                </div> */}
                            </div>
                        </div>
                    ))}
                    {filteredSMLeads.length > 0 && filteredSMLeads.filter((lead, index) => { return index >= 10 ? false : true; }).map((option, index) => (
                        <div key={index} style={{ cursor: "pointer" }} onClick={() => carIdSearch(option.id)}>
                            <div className="autocomplete-items d-flex align-items-center">
                                {option?.Vehicle_Photos ?
                                    <div className="cssl-img position-relative">
                                        <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                        {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> : ""}
                                    </div> :
                                    <div className='pd-no-img position-relative no-photo-pos'>
                                        <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                    </div>
                                }
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option.year ? option.year : ""} {option?.make}</div>
                                    <div className="pd-xs-title my-2">{option?.full_name}</div>
                                    <div className="pd-email">{option.email}</div>
                                </div>
                                {/* }
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                    <div className="pd-xs-title my-2">{option?.first_name} {option.last_name}</div>
                                    <div className="pd-email">{option.email}</div>
                                </div> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default AutoComplete;
